import { cn } from "@/lib/utils";
import {
  Popover as AriaPopover,
  type PopoverProps as AriaPopoverProps,
  composeRenderProps,
} from "react-aria-components";

const Popover = ({
  className,
  offset = 4,
  placement = "bottom",
  ...props
}: AriaPopoverProps) => (
  <AriaPopover
    offset={offset}
    placement={placement}
    className={composeRenderProps(className, (className) =>
      cn(
        "border-gray-200 shadow",
        "z-50 rounded-md border bg-popover text-popover-foreground shadow-md outline-hidden",
        "data-hovered:bg-gray-100",
        /* Entering */
        "data-entering:animate-in data-entering:fade-in-0 data-entering:zoom-in-95",
        /* Exiting */
        "data-exiting:animate-out data-exiting:fade-out-0 data-exiting:zoom-out-95",
        /* Placement */
        "data-[placement=bottom]:slide-in-from-top-2 data-[placement=left]:slide-in-from-right-2 data-[placement=right]:slide-in-from-left-2 data-[placement=top]:slide-in-from-bottom-2",
        className,
      ),
    )}
    {...props}
  />
);

export { Popover };
